@import '~style-sheet-helpers/core.less';

.shipment-status {
  display: flex;
  flex-direction: row;
}

.label-printed-icon {
  padding: 6px;
}

.label-purchased-icon {
  padding: 7px;
}

.plane-icon {
  padding: 6px;
}

.packing-slip-icon {
  padding: 7px;
}
